import { useRef, useEffect } from 'react';


/**
 * Returns the previous value (or undefined if there is no previous value) -- gives you a len(1) history of the given
 * value.
 */
export const usePrevious = <T>(value: T): T | undefined => {
  const prevRef = useRef<T | undefined>(undefined);

  useEffect(() => {prevRef.current = value;}, [value]);

  return prevRef.current;
};
